module.exports = __webpack_public_path__ + "view/img/house.f74fd68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/house.png
// module id = 2nm8
// module chunks = 13